import { useContext } from 'react';

import { GlobalLoaderContext } from '../provider/GlobalLoaderProvider/GlobalLoaderContext';

import type { GlobalLoaderDispatchContextParams } from '../provider/GlobalLoaderProvider/GlobalLoaderContext';

const useGlobalLoader = <
  LoaderComponentProps extends Record<string, unknown> = Record<string, unknown>,
>() => {
  const context = useContext(GlobalLoaderContext);
  return context as GlobalLoaderDispatchContextParams<LoaderComponentProps>;
};

export default useGlobalLoader;
